module.exports = require("@agm/core/services/managers/polyline-manager");